<div class="main-page">
  <div class="container">
    <ngx-ui-loader [loaderId]="'loader-01'"></ngx-ui-loader>
    <div class="mm-jobs-wrap">
      <div class="mm-jobs-container">
        <div class="mm-jobs-header">
          <div class="mm-jobs-titleblock">
            <h4 class="mm-jobs-title">
              <i class="fas fa-briefcase mm-jobs-title-icon" aria-hidden="true"></i>
              My Jobs
            </h4>
            <div class="mm-jobs-subtitle">
              Manage your job postings and track applications.
              <span class="mm-jobs-count">({{ jobs?.length || 0 }} jobs)</span>
            </div>
          </div>

          <button (click)="createJob()" class="mm-btn-create">
            <i class="fas fa-plus" aria-hidden="true"></i> Add Job
          </button>
        </div>

        <div *ngIf="jobs?.length === 0" class="mm-empty">
          <img class="mm-empty-img" src="../../assets/no-data.png" alt="No jobs available" />
          <h5 class="mm-empty-title">No Jobs Available</h5>
          <p class="mm-empty-subtitle">Create your first job posting to get started.</p>
          <button (click)="createJob()" class="mm-btn-create mm-btn-create--empty">
            <i class="fas fa-plus" aria-hidden="true"></i> Add Job
          </button>
        </div>

        <div class="mm-jobs-grid" *ngIf="jobs?.length > 0">
          <div class="mm-job-card" *ngFor="let job of pagedJobs; let i = index" [style.animation-delay]="(i * 0.05) + 's'">
            <div class="mm-job-header">
              <div class="mm-job-title-section">
                <h5 class="mm-job-title">{{ job?.jobBasics?.title || 'Untitled Job' }}</h5>
                <div class="mm-job-company">{{ job?.jobPost?.companyName || '-' }}</div>
              </div>
              <div class="mm-job-badges">
                <span class="mm-badge" [class.mm-badge--expired]="isJobExpired(job?.activeTill)">
                  {{ isJobExpired(job?.activeTill) ? 'Expired' : 'Active' }}
                </span>
                <span class="mm-badge mm-badge--type" *ngIf="job?.jobBasics?.remoteJob">
                  Remote
                </span>
              </div>
            </div>

            <div class="mm-job-body">
              <div class="mm-job-row">
                <div class="mm-job-label">
                  <i class="fas fa-industry" aria-hidden="true"></i> Industry
                </div>
                <div class="mm-job-value">
                  {{ job?.jobBasics?.industry || '-' }}
                </div>
              </div>

              <div class="mm-job-row" *ngIf="job?.jobBasics?.category">
                <div class="mm-job-label">
                  <i class="fas fa-tag" aria-hidden="true"></i> Category
                </div>
                <div class="mm-job-value">
                  {{ job.jobBasics.category }}
                </div>
              </div>

              <div class="mm-job-row">
                <div class="mm-job-label">
                  <i class="fas fa-briefcase" aria-hidden="true"></i> Job Type
                </div>
                <div class="mm-job-value">
                  {{ job?.jobDetails?.jobType || '-' }}
                </div>
              </div>

              <div class="mm-job-row" *ngIf="job?.jobDetails?.jobPay">
                <div class="mm-job-label">
                  <i class="fas fa-dollar-sign" aria-hidden="true"></i> Pay
                </div>
                <div class="mm-job-value">
                  {{ job.jobDetails.jobPay }}
                </div>
              </div>

              <div class="mm-job-row">
                <div class="mm-job-label">
                  <i class="fas fa-map-marker-alt" aria-hidden="true"></i> Location
                </div>
                <div class="mm-job-value mm-clamp-1">
                  {{ getJobLocation(job) }}
                </div>
              </div>

              <div class="mm-job-row" *ngIf="job?.applicationSettings?.receiveType">
                <div class="mm-job-label">
                  <i class="fas fa-envelope" aria-hidden="true"></i> Applications
                </div>
                <div class="mm-job-value">
                  Via {{ job.applicationSettings.receiveType }}
                </div>
              </div>

              <div class="mm-job-row" *ngIf="job?.activeTill">
                <div class="mm-job-label">
                  <i class="fas fa-calendar-alt" aria-hidden="true"></i> Active Until
                </div>
                <div class="mm-job-value">
                  {{ formatDate(job.activeTill) }}
                </div>
              </div>

              <div class="mm-job-description" *ngIf="job?.jobDetails?.jobDuties">
                <p class="mm-clamp-2">{{ job.jobDetails.jobDuties }}</p>
              </div>
            </div>
          </div>
        </div>

        <div class="mm-pagination" *ngIf="jobs?.length > 0 && totalPages > 1">
          <button class="mm-page-btn" (click)="prevPage()" [disabled]="page <= 1">
            <i class="fas fa-chevron-left" aria-hidden="true"></i> Previous
          </button>
          <span class="mm-page-info">Page {{ page }} of {{ totalPages }}</span>
          <button class="mm-page-btn" (click)="nextPage()" [disabled]="page >= totalPages">
            Next <i class="fas fa-chevron-right" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
